t = require('app/scripts/views/internal/teacup-with-helpers')('edit_controls')

module.exports = ->
  t.div '.edit-controls.u-clearfix', ->
    t.input '.primary.confirm.mod-submit-edit.js-save-edit', { type: 'submit', value: t.l('save') }
    t.a '.icon-lg.icon-close.dark-hover.cancel.js-cancel-edit', { href: '#' }

    t.div '.edit-controls-spacer'

    t.a '.option.check-item-options-menu.dark-hover.js-assign.hide', { href: '#' }

    t.a '.option.check-item-options-menu.dark-hover.js-due.checklist-add-controls-due.hide', { href: '#' }

    t.a '.option.check-item-options-menu.dark-hover.js-open-emoji-selector', { href: '#' }, ->
      t.span '.icon-sm.icon-emoji'

    t.a '.option.check-item-options-menu.dark-hover.js-open-mention-selector', { href: '#' }, ->
      t.span '.icon-sm.icon-mention'

    t.a '.option.check-item-options-menu.dark-hover.js-open-menu', { href: '#' }, ->
      t.span '.icon-sm.icon-overflow-menu-horizontal'


